import * as React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import BAVRadioGroup from "./BAVRadioGroup";
import { useState, useEffect } from "react";
import imgAusgewogen from "../images/strat_ausgewogen.png";
import imgEinkommen from "../images/strat_einkommen.png";
import imgKapitalgewinn from "../images/strat_kapitalgewinn.png";
import imgWachstum from "../images/strat_wachstum.png";
import imgZinsertrag from "../images/strat_zinsertrag.png";

function BAVStrategy(props) {

    const { responses, readOnly, callback } = props;
    const [img, setImage] = useState();
    const [value, setValue] = useState();
    const handleChange = (event, radioGroupValue, response) => {
        setValue(radioGroupValue);
        var img;
        switch (radioGroupValue) {
            case "81":
            case "120":
            case "153":
                img = imgZinsertrag;
                break;
            case "82":
            case "121":
            case "154":
                img = imgEinkommen;
                break;
            case "83":
            case "122":
            case "155":
                img = imgAusgewogen;
                break;
            case "84":
            case "123":
            case "156":
                img = imgWachstum;
                break;
            case "85":
            case "124":
            case "157":
                img = imgKapitalgewinn;
                break;
        }
        setImage(img);
        if (typeof callback == "function" && event !== null) {
            callback(event, radioGroupValue, response);
        }
    };

    return (

                    <Grid container sx={{ marginTop: 2 }}>
                        <Grid item xs={2}>
                           <BAVRadioGroup
                                responses={responses}
                                callback={handleChange}
                                invStrat={1}
                                readOnly={readOnly}
                             />
                        </Grid>

                        <Grid item xs={10}  >
                            <img src={img} style={{ width: "95%" }} />
                        </Grid>
                    </Grid>
    );
}
export default BAVStrategy;
